import siFetch from "api/fetch";

const dashboard = (init = null) => siFetch(`/api/v1/agent/dashboard`, init);

export default dashboard;
